import { render } from "./SubscriptionError.vue?vue&type=template&id=bb65e95c&scoped=true"
import script from "./SubscriptionError.vue?vue&type=script&lang=js"
export * from "./SubscriptionError.vue?vue&type=script&lang=js"

import "./SubscriptionError.vue?vue&type=style&index=0&id=bb65e95c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb65e95c"]])

export default __exports__